"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";

const BoligsidenbadgeSectionComponent: React.FC<
  SectionProps<{
    badgekode: string;
    overskrift: string;
    beskrivelse: string;
  }>
> = ({ cmsSection }) => {
  return (
    <SectionLayout cmsSection={getDefaultCmsSection(cmsSection)}>
      <div className="flex flex-1 flex-col homepage-text-sm bg-white p-4">
        {cmsSection?.specifics.overskrift && (
          <div className="homepage-text-lg">
            {cmsSection?.specifics.overskrift}
          </div>
        )}
        {cmsSection?.specifics.beskrivelse && (
          <div
            className="styled-description"
            dangerouslySetInnerHTML={{
              __html: cmsSection?.specifics.beskrivelse ?? "",
            }}
          />
        )}
        <div className="place-items-center">
          <iframe
            src={`https://maegler.boligsiden.dk/badge/index/${cmsSection?.specifics.badgekode}`}
          ></iframe>
        </div>
      </div>
    </SectionLayout>
  );
};

export default BoligsidenbadgeSectionComponent;
